/**
 * There are variations of the password reset page depending on the context.
 *
 * The REGISTER variant is used when the user is setting the password for the first time.
 * The AUTH variant is used when the user is resetting the password.
 */
export enum PasswordResetPageVariant {
  REGISTER = 'REGISTER',
  AUTH = 'AUTH',
}

/**
 * A map from the requirement description to the function which evaulates the requirement.
 */
const MINIMUM_PASSWORD_LENGTH = 8;
export const PASSWORD_REQUIREMENTS: { [description: string]: (password: string) => boolean } =
  Object.freeze({
    [`Be at least ${MINIMUM_PASSWORD_LENGTH} characters long`]: (password: string) =>
      password.length >= MINIMUM_PASSWORD_LENGTH,
    'Contain at least one lowercase letter': (password: string) => /[a-z]/.test(password),
    'Contain at least one uppercase letter': (password: string) => /[A-Z]/.test(password),
    'Contain at least one special character (!@#$%^&*)': (password: string) =>
      /[!@#$%^&*]/.test(password),
  });

export function passwordSatisfiesRequirements(password: string): boolean {
  return Object.entries(PASSWORD_REQUIREMENTS).every(([_, condition]) => condition(password));
}
